import {
    postInvoiceLoading,
    postInvoiceRequest,
    postInvoiceSuccess,
    postInvoiceReject,
    postInvoiceReset
} from "../../actions/invoice/post";

export const postInvoice = (formData) => async (dispatch, getState) => {
    dispatch(postInvoiceLoading());
    try {
        const { data } = await postInvoiceRequest(formData, getState);
        dispatch(postInvoiceSuccess(data))
    } catch (error) {
        dispatch(postInvoiceReject(error))
    } finally {
        setTimeout(() => { dispatch(postInvoiceReset()) }, 3000);
    }
    return Promise.resolve();
};